// The patient voice library: stock phrases, each recorded once per voice by scripts/make-voices.mjs
// (Gemini text-to-speech) into voices/<voice>/<phrase>.mp3. data/voice-clips.js lists which clips exist;
// a phrase with no clip for the chosen voice falls back to the device's built-in voice.
// mood (optional) overrides the usual "unwell and worried" delivery. Sounds (groans, coughs) have no words:
// tags are what the voice performs, heard what the check must hear, and they only show once their clips exist.
window.VOICE_LIBRARY = {
    voices: [
        // gemini: a voice from Google's TTS voice list (GET /v1beta/voices); style: how it is spoken.
        { id: "man", label: "Man", gemini: "en-gb-podcaster-9", style: "a man in his forties" },
        { id: "woman", label: "Woman", gemini: "en-gb-assistant-3", style: "a woman in her forties" },
        { id: "older-man", label: "Older man", gemini: "en-gb-csagent-3", style: "a frail elderly man in his late seventies, slow and a little shaky" },
        { id: "older-woman", label: "Older woman", gemini: "en-gb-training-2", style: "a frail elderly woman in her late seventies, slow and a little shaky" },
        { id: "teen", label: "Teenager", gemini: "en-gb-csagent-13", style: "a teenage boy of about fifteen" },
        { id: "child", label: "Child", gemini: "en-gb-csagent-8", style: "a young child of about seven with a small, high voice" },
    ],
    groups: [
        { label: "Answers", phrases: [
            { id: "yes", text: "Yes." },
            { id: "no", text: "No." },
            { id: "i-dont-know", text: "I don't know." },
            { id: "im-not-sure", text: "I'm not sure." },
            { id: "sorry-what", text: "Sorry, what?" },
            { id: "can-you-say-that-again", text: "Can you say that again?" },
            { id: "ok", text: "OK." },
            { id: "please-help-me", text: "Please help me." },
            { id: "thank-you", text: "Thank you.", mood: "tired but grateful" },
        ] },
        { label: "Pain", phrases: [
            { id: "my-chest-really-hurts", text: "My chest really hurts." },
            { id: "its-like-a-heavy-weight-on", text: "It's like a heavy weight on my chest." },
            { id: "the-pains-going-down-my-left", text: "The pain's going down my left arm." },
            { id: "its-a-sharp-pain-worse-when", text: "It's a sharp pain, worse when I breathe in." },
            { id: "my-stomachs-killing-me", text: "My stomach's killing me." },
            { id: "the-pain-is-ten-out-of", text: "The pain is ten out of ten." },
            { id: "about-a-six-out-of-ten", text: "About a six out of ten." },
            { id: "it-hurts-when-you-press-there", text: "It hurts when you press there." },
            { id: "my-head-is-pounding", text: "My head is pounding." },
            { id: "worst-headache-of-my-life", text: "Worst headache of my life." },
            { id: "my-back-is-agony", text: "My back is agony." },
            { id: "my-leg-really-hurts-i-cant", text: "My leg really hurts, I can't move it." },
            { id: "ow-that-hurts", text: "Ow! That hurts!", mood: "in sudden sharp pain" },
            { id: "please-give-me-something-for-the", text: "Please give me something for the pain." },
        ] },
        { label: "Breathing", phrases: [
            { id: "i-cant-breathe", text: "I can't breathe.", mood: "panicky and breathless" },
            { id: "i-cant-catch-my-breath", text: "I can't... catch my breath.", mood: "panicky and breathless" },
            { id: "my-chest-feels-tight", text: "My chest feels tight." },
            { id: "im-wheezing-i-need-my-inhaler", text: "I'm wheezing, I need my inhaler." },
            { id: "ive-been-coughing-up-green-stuff", text: "I've been coughing up green stuff." },
            { id: "ive-coughed-up-some-blood", text: "I've coughed up some blood." },
        ] },
        { label: "Heart", phrases: [
            { id: "my-hearts-racing", text: "My heart's racing." },
            { id: "i-feel-like-im-going-to", text: "I feel like I'm going to pass out." },
            { id: "i-feel-dizzy", text: "I feel dizzy." },
            { id: "i-feel-really-sick", text: "I feel really sick." },
            { id: "im-going-to-be-sick", text: "I'm going to be sick." },
            { id: "i-feel-cold-and-clammy", text: "I feel cold and clammy." },
            { id: "i-blacked-out", text: "I blacked out." },
        ] },
        { label: "Allergy", phrases: [
            { id: "my-throat-feels-tight", text: "My throat feels tight." },
            { id: "my-lips-are-swelling", text: "My lips are swelling." },
            { id: "im-allergic-to-penicillin", text: "I'm allergic to penicillin." },
            { id: "i-dont-have-any-allergies", text: "I don't have any allergies." },
            { id: "im-itchy-all-over", text: "I'm itchy all over." },
            { id: "ive-been-stung-by-a-wasp", text: "I've been stung by a wasp." },
        ] },
        { label: "Confused", phrases: [
            { id: "where-am-i", text: "Where am I?", mood: "confused and drowsy" },
            { id: "whats-happening", text: "What's happening?", mood: "confused and drowsy" },
            { id: "i-cant-move-my-arm", text: "I can't move my arm." },
            { id: "my-face-feels-funny", text: "My face feels funny." },
            { id: "i-cant-see-properly", text: "I can't see properly." },
            { id: "i-dont-remember-what-happened", text: "I don't remember what happened.", mood: "confused and drowsy" },
            { id: "what-day-is-it", text: "What day is it?", mood: "confused and drowsy" },
            { id: "who-are-you", text: "Who are you?", mood: "confused and drowsy" },
        ] },
        { label: "History", phrases: [
            { id: "it-started-about-an-hour-ago", text: "It started about an hour ago." },
            { id: "it-came-on-suddenly", text: "It came on suddenly." },
            { id: "its-been-getting-worse-over-a", text: "It's been getting worse over a few days." },
            { id: "i-take-tablets-for-my-blood", text: "I take tablets for my blood pressure." },
            { id: "im-on-blood-thinners", text: "I'm on blood thinners." },
            { id: "im-diabetic-i-take-insulin", text: "I'm diabetic, I take insulin." },
            { id: "ive-got-asthma", text: "I've got asthma." },
            { id: "ive-had-a-heart-attack-before", text: "I've had a heart attack before." },
            { id: "ive-had-a-couple-of-drinks", text: "I've had a couple of drinks." },
            { id: "i-took-some-tablets", text: "I took some tablets." },
            { id: "i-took-all-my-tablets", text: "I took all my tablets." },
            { id: "im-pregnant", text: "I'm pregnant." },
            { id: "i-think-i-might-be-pregnant", text: "I think I might be pregnant." },
        ] },
        { label: "Feelings", phrases: [
            { id: "im-scared", text: "I'm scared.", mood: "frightened" },
            { id: "am-i-going-to-die", text: "Am I going to die?", mood: "frightened" },
            { id: "please-dont-leave-me", text: "Please don't leave me.", mood: "frightened" },
            { id: "is-my-family-here", text: "Is my family here?" },
            { id: "i-want-to-go-home", text: "I want to go home." },
            { id: "leave-me-alone", text: "Leave me alone!", mood: "angry and agitated" },
            { id: "get-off-me", text: "Get off me!", mood: "angry and agitated" },
            { id: "dont-touch-me", text: "Don't touch me!", mood: "angry and agitated" },
            { id: "im-fine-i-dont-need-to", text: "I'm fine, I don't need to be here.", mood: "irritable and dismissive" },
            { id: "i-feel-a-bit-better-now", text: "I feel a bit better now.", mood: "tired but relieved" },
            { id: "thats-much-better-thank-you", text: "That's much better, thank you.", mood: "relieved and grateful" },
        ] },
        { label: "Children", phrases: [
            { id: "i-want-my-mum", text: "I want my mum." },
            { id: "i-want-my-dad", text: "I want my dad." },
            { id: "is-it-going-to-hurt", text: "Is it going to hurt?" },
            { id: "i-dont-like-needles", text: "I don't like needles." },
            { id: "i-fell-off-my-bike", text: "I fell off my bike." },
            { id: "my-tummy-hurts", text: "My tummy hurts." },
        ] },
        { label: "Trauma", phrases: [
            { id: "i-came-off-my-motorbike", text: "I came off my motorbike." },
            { id: "a-car-hit-me", text: "A car hit me." },
            { id: "i-fell-down-the-stairs", text: "I fell down the stairs." },
            { id: "i-cant-feel-my-legs", text: "I can't feel my legs." },
            { id: "my-neck-hurts", text: "My neck hurts." },
            { id: "i-hit-my-head", text: "I hit my head." },
        ] },
        { label: "Sounds", sounds: true, phrases: [
            { id: "groan", text: "Groan", tags: "<groan>", heard: "groan|moan|grunt" },
            { id: "moan", text: "Moaning", tags: "<moan> <short pause> <moan>", heard: "moan|groan|whimper" },
            { id: "gasp", text: "Gasp", tags: "<gasp>", heard: "gasp|breath|inhale|pant" },
            { id: "scream", text: "Scream", tags: "<scream>", heard: "scream|shout|yell|cry" },
            { id: "cough", text: "Cough", tags: "<cough> <cough>", heard: "cough" },
            { id: "crying", text: "Crying", tags: "<sob> <short pause> <sob>", heard: "sob|cry|weep|whimper" },
            { id: "sigh", text: "Sigh", tags: "<sigh>", heard: "sigh|exhale" },
            { id: "snore", text: "Snoring", tags: "<snore> <long pause> <snore>", heard: "snor" },
        ] },
    ]
};
